import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import SIVAKKIYAR from "../images/SIVAKKIYAR.png";



export default function Navbar() {
  return (
    <>
      {/* ✅ Custom Language Bar */}
    

      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <div className="d-flex align-items-center w-100 justify-content-between">
            <div className="d-flex align-items-center">
              <Link to="/" className="navbar-image">
                <img
                  src={SIVAKKIYAR}
                  alt="SIVAKKIYAR"
                  className="navbar-logo"
                />
              </Link>
              <Link className="navbar-brand" to="/">
                Shiva Nadi Astrology
              </Link>
            </div>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav w-100 justify-content-center">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/About">
                  About
                </Link>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/Palmleaf"
                  id="nadiAstrologyDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Nadi Astrology
                </Link>

                <ul
                  className="dropdown-menu"
                  aria-labelledby="nadiAstrologyDropdown"
                >
                  <li>
                    <Link className="dropdown-item" to="/Whatastro">
                      What Is Nadi Astrology?
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/History">
                      History Of Nadi
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/Chapters">
                      Chapters Of Nadi
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/Remedycard">
                      Remedies
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/Palmleaf">
                      Palmleaf Reading
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/onlineconsult">
                  Online Consultation
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Gallery">
                  Gallery
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
